<template>

    <div>
        <CoolLightBox :items="[image]"
                      :index="index"
                      @close="index = null">
        </CoolLightBox>

        <div class="animal-photo flex-grow-0 mr-5 mb-4 position-relative">
            <img class="position-relative" :src="backgroundImage" @load="onSrcLoaded"  @click="index = 0" alt="Фото животного" />
            <b-button v-if="image && canEdit"
                      @click="onClick"
                      variant="link"
                      class="edit-button"
                      v-b-tooltip="'Загрузить новое фото'">
                <b-icon icon="pencil" class="edit-button-icon mr-2"/>
            </b-button>
            <div v-else-if="canEdit"
                 class="position-absolute d-flex flex-column w-100 h-100
                 align-items-center justify-content-center"
                 style="top:0">
                <b-button @click="onClick" variant="link">
                    <b-icon icon="plus" class="mr-2"/>
                    <span>Загрузить фото</span>
                </b-button>
            </div>
            <input class="form-control d-none" ref="input" type="file" @change="onChange" accept="image/jpeg">
            <transition name="fade">
                <div v-if="updating"
                     class="position-absolute d-flex flex-column w-100 h-100
                     align-items-center justify-content-center bg-light"
                     :style="{'background-image': `url(${placeholder})`, top: '0'}">
                    <b-spinner variant="info" size="lg"/>
                </div>
            </transition>
        </div>
    </div>

</template>

<script>
    import { mapGetters } from 'vuex';
    import placeholder from '../../../assets/img/animal_placeholder.png'
    import api from "../../../api";
    import httpClient from "../../../http";
    import CoolLightBox from "vue-cool-lightbox";
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

    export default {
        name: "AnimalPrimaryAvatar",
        components: { CoolLightBox },
        props: {
            animal: { type: Object },
            image: { type: String }
        },
        data() {
            return {
                placeholder,
                avatarId: null,
                updating: false,
                index: null
            }
        },
        computed: {
            ...mapGetters(['ability']),
            canEdit() {
                return this.ability.can('update', this.animal);
            },
            uploadUrl() {
                return api.attachments.default.list()
            },
            assignUrl() {
                return api.animals.default.detail(this.animal.id)
            },
            backgroundImage() {
                return this.image ? this.image : this.placeholder;
            },
            assignImmediately() {
                return Boolean(this.animal.id)
            }
        },
        methods: {
            onClick() {
                this.$refs.input.click();
            },
            async upload() {
                const vm = this;
                let file = vm.$refs.input.files[0];
                let formData = new FormData();
                formData.append('file', file);

                const response = await httpClient.post(
                    vm.uploadUrl,
                    formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                );

                return response.data
            },
            async assign(attachmentId) {
                return await httpClient.patch(
                    this.assignUrl,
                    {avatar: attachmentId}
                )
            },
            async onChange() {
                const vm = this;

                vm.updating = true;
                const avatar = await vm.upload().catch(error => {
                    vm.$bvToast.toast('Не удалось загрузить новое фото',
                        {solid: true, noCloseButton: true, variant: 'danger', autoHideDelay: 5000});
                    vm.updating = false;
                });

                if (avatar && avatar.hasOwnProperty('id')) {
                    vm.avatarId = avatar['id'];
                    this.$emit('animal-avatar-uploaded', {id: vm.avatarId, image: avatar['absolute_url']});

                    if (this.assignImmediately) {
                        const response = await vm.assign(vm.avatarId).catch(error => {
                            vm.$bvToast.toast('Не удалось установить новое фото',
                                {solid: true, noCloseButton: true, variant: 'danger', autoHideDelay: 5000});
                            vm.updating = false;
                        });

                        this.$emit('animal-avatar-updated', response.data);
                        vm.$bvToast.toast('Новое фото установлено',
                            {solid: true, noCloseButton: true, variant: 'success', autoHideDelay: 5000});
                    }
                }
            },
            onSrcLoaded() {
                this.updating = false;
            }
        }
    }
</script>

<style scoped lang="scss">

    @import "node_modules/bootstrap/scss/functions";
    @import 'node_modules/bootstrap/scss/variables';

    .animal-photo {
        //width: 100%;
        max-width: 480px;
        max-height: 420px;
        border-radius: 8px;

        & div {
            //width: 100%;
            max-width: 480px;
            height: 420px;
            background-size: cover;
            border-radius: 8px;
        }
        & img {
            //width: 100%;
            max-width: 480px;
            max-height: 420px;
            border-radius: 8px;
            cursor: pointer;
        }
    }

    .edit-button {
        background-color: white;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 5px;
        top: 5px;
        border: 0;

        transition: 0.2s;
        &:hover {
            transform: scale(1.1);
        }
    }

    .edit-button-icon {
        position: absolute;
        left: 8px;
        top: 7px;
        pointer-events: none;
        font-size: 1.6em;
        color: $gray-600;

    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
      opacity: 0;
    }

</style>